import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ViewContainer from '@workflow/containers/ViewContainer.vue'
import ApprovalProcessingModal from '@workflow/components/Modals/ApprovalProcessingModal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CommentModal from '@workflow/components/Modals/CommentModal.vue'
import * as types from '@workflow/store/types'
import api from '@workflow/api'
import * as accountTypes from '@account/store/types'
import * as globalTypes from '@/store/types'
@Component({
    components: { PageViewHeaderWithActionBar, ViewContainer, ApprovalProcessingModal,CommentModal },
    computed: {
        ...mapGetters({
            current: types.WORKFLOW_CURRENT,
            User: accountTypes.USER,
            currentPage: globalTypes.CURRENT_PAGE,
            workflowOptions: types.GET_WORKFLOW_OPTIONS
        })
    },
    methods: {
        ...mapMutations({
           
        }),
        ...mapActions({
            setCurrent: types.WORKFLOW_CURRENT,
            setWorkflowOptions: types.GET_WORKFLOW_OPTIONS
        })
    }
})
export default class ReadView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    setCurrent!: (data: any) => Promise<any>;
    setWorkflowOptions!: () => Promise<any>

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    current!: workflow.CM_Form
    User!: account.User
    currentPage!: object
    workflowOptions!: { application: any, system: any };

    toggleCommentModal: boolean = false;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    approvalMenu: number[] = [3, 20] // 결재, 수신
    showModal: boolean = false
    actionItem: workflow.TC_APM_MENUS | null = null

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get IsExistComment() {
        var list = this.current?.approvalLineList?.filter((x:any) => x.approverComment);
        var bResult = (list?.length || 0) > 0;
        return bResult;
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /**
     * 의견 모달창을 엽니다.
     */
    showCommentModal(){
        this.toggleCommentModal = true
    }

    /**
     * 액션 가능한 메뉴 그룹 아이템을 가져옵니다.
     */
    getActionItems() {
        var list = this.current.menus?.filter((x: any) => 
                    !x.parentMenuId && x.isRead != this.current.isEdit && !x.isHide && x.isMobile)
        list = list?.sort((a:any, b:any) => a.order - b.order)
        return list
    }

    /**
     * 액션 아이템 아이콘 이미지 url을 반환합니다.
     */
    getActionImgUrl(item: any) {
        var url = '';
        if (item.iconName) {
            url = item.iconName + '?v=1';
        } else {
            url = '/cm/gres/workflow/workflow/images/mn_03.png';
        }
        return url;
    }

    /**
     * 옵션 값을 조회합니다
     */
    loadData(){
        this.getOptionValues([
            'IsOnePersonApproval', 
            'IsAbleToDisplayCommentsFirst', 
            'IsAbleToDisplaySubject', 
            'IsSignatureLineLayout', 
            'ApprovalEditPermission', 
            'IsChangeDagLine',
            'ApproverEditPermission', 
            'IsDirectDocNumber']);
    }

    /**
     * 액션 모달창을 엽니다.
     */
    openModal(item: any) {
        this.showModal = true
        this.actionItem = item
    }

    async action(item: workflow.TC_APM_MENUS) {

        if (item.isGroup) { // 그룹 액션 메뉴는 모달에서 처리함

            // ISU Custom Valid
                
            // 외부 수신의 경우
            if (this.current.lineRoleList?.filter((x) => x == 'OuterRequester').length) {
                // 외부 수신 접수 상태의 경우
                if (item.menuName == 'ISU_외부결재') {
                    var requesters = this.current.approvalLineList?.filter(x => x.approvalStatus == 'DU' && x.approverCode == this.User.personCode);
                    if (requesters?.length) {
                        var requester = requesters[0];
                        if (this.current.approvalLineList?.filter((x) => x.parentApprovalLineId == requester.parentApprovalLineId).length == 1
                            && this.current.approvalLineList?.filter((x) => x.sortNumber > 0 && x.approvalStatus == 'A3' && x.approverType == 'AU' && x.lineType != 'SG').length == 0) {
                            if (!await(window as any).confirmAsync(this.$t('본인전결_하시겠습니까').toString())) {
                                return;
                            }
                        }
                    }
                }
            }

            // 내부 수신의 경우
            if (this.current.lineRoleList?.filter((x) => x == 'InnerRequester').length) {
                // 내부 수신 접수 상태의 경우
                if (item.menuName == 'ISU_내부결재') {
                    var requesters = this.current.approvalLineList?.filter(x => x.approvalStatus == 'DA' && x.approverCode == this.User.personCode);
                    if (requesters?.length) {
                        var requester = requesters[0];
                        if (this.current.approvalLineList?.filter((x) => x.parentApprovalLineId == requester.parentApprovalLineId && x.lineType != 'SG').length == 1) {
                            if (!await(window as any).confirmAsync(this.$t('본인전결_하시겠습니까').toString())) {
                                return;
                            }
                        }
                    }
                }
            }
            this.showModal = true
            this.actionItem = item
        } else {
            if (item.actionId) {

                // ISU Custom Valid
                if (item.menuName == 'ISU_접수취소') {
                    if (!await(window as any).confirmAsync(this.$t('접수취소를_하시겠습니까').toString())) {
                        return;
                    }
                }

                if (item.actionId == 'DD') {
                    if (!await(window as any).confirmAsync(this.$t('정말_삭제하시겠습니까_삭제_시_복원할_수_없습니다').toString())) {
                        return;
                    }
                }

                var data: any = {
                    actionId: item.actionId,
                    nextActionList: item.nextActionList,
                    comment: null,
                    personCode: this.User.personCode,
                    application: this.current.application,
                    apm: this.current.apm,
                    apmDetail: this.current.apmDetail,
                    apmConnectList: this.current.apmConnectList,
                    approvalLineList: this.current.approvalLineList,
                    isMobile: true
                }
                api.form.actionForm(data).then(async res => {
                    if (res.isError) {
                        await(window as any).alertAsync(res.message)
                    } else {
                        if (res.isRedirect) {
                            var actionMessage = '';
                            let actionId = data.actionId.toUpperCase();
        
                            switch (actionId) {
                                case 'RT':
                                    actionMessage = this.$t('문서를_회수했습니다').toString();
                                    break;
                                case 'AP':
                                    actionMessage = this.$t('문서를_상신했습니다').toString();
                                    break;
                                case 'AV':
                                    actionMessage = this.$t('문서를_승인했습니다').toString();
                                    break;
                                case 'RJ':
                                    actionMessage = this.$t('문서를_반송했습니다').toString();
                                    break;
                                case 'DA':
                                    actionMessage = this.$t('문서를_접수했습니다').toString();
                                    break;
                                case 'DU':
                                    actionMessage = this.$t('문서를_접수했습니다').toString();
                                    break;
                                case 'TD':
                                case 'DD':
                                    actionMessage = this.$t('문서를_삭제했습니다').toString();
                                    break;
                                case 'RS':
                                    actionMessage = this.$t('문서를_복원했습니다').toString();
                                    break;
                            }
        
                            if (actionMessage) {
                                await(window as any).alertAsync(actionMessage);
                            }
                        }
        
                        window.history.back();
                        
                    }
                }).catch((err) => {
                    console.log(err)
                })
                
            } else {
                switch (item.menuName) {
                    case '의견':
                        this.toggleCommentModal = true;
                        break;
                }
            }
        }

        
    }

    /**
     * 액션 모달창을 닫고 결재함 목록으로 이동합니다.
     */
     showModalGotoList() {
        this.showModal = false
        window.history.back();
    }

    /**
     * 옵션 값을 조회하여 해당 변수에 값을 할당합니다
     */
    getOptionValues(props: Array<string>) {
        props.forEach((prop: string) => {
            var appValues: Array<any> = this.workflowOptions.application[prop];
            var sysValue: any = this.workflowOptions.system[prop];
            // 양식별 옵션 값이 있는 경우
            if (appValues !== undefined && appValues.length) {
                if (appValues.length > 1 && this.$route.query.appid && this.$route.query.appid !== undefined) {
                    var applicationId = this.$route.query.appid.toString();
                    var idx = appValues.findIndex(x => x.applicationId !== null && x.applicationId.toString() === applicationId);
                    // index 0 은 공통 옵션 값임
                    if (idx > 0) {
                        (this as any)[prop] = appValues[idx].value;
                    }
                    else {
                        (this as any)[prop] = appValues[0].value;
                    }

                }
                else {
                    (this as any)[prop] = appValues[0].value;
                }
            }
            if (sysValue && sysValue !== undefined) {
                (this as any)[prop] = sysValue;
            }
        })
    }

    @Watch('$route.query')
    onQueryChanged(newValue: any, oldValue: any) {
        // console.log('onQueryChanged', newValue);
        // 기안하기 페이지에서 양식을 변경하는 경우 다시 로드해야함
        // 재사용시와 충돌하지 않도록 조건 수정함
        if (newValue.appid && newValue.storekey !== oldValue.storekey) {
            this.loadData();
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        var data: any = {
            apmId: Number(this.$route.query.apmid), // 문서번호
            personCode: this.User.personCode,
            isMobile: true
        }


        this.setCurrent(data).then(res => {
        })
        this.getActionItems()
        this.setWorkflowOptions().then(()=>{
            this.loadData();
        })
        this.toggleCommentModal = this.IsExistComment;

    }

    // isApprovalPossible() {
    //     var isProssible = false;
    //     if (this.current.menus) {
    //         if (this.current.menus?.filter((x: any) => 
    //             !x.parentMenuId && x.isRead != this.current.isEdit && this.approvalMenu.indexOf(x.menuId) != -1).length
    //         ) {
    //             isProssible = true;
    //         }
    //     }
    //     return isProssible;
    // }
    // IsAbleToDisplayCommentsFirst:boolean = false;
    // get ShowCommentModal() {
    //     return this.current.isEdit === false && this.IsAbleToDisplayCommentsFirst && (this.current.approvalLineList?.length ? this.current.approvalLineList.findIndex((x:any) => x.approverComment || '') > -1 : false);
    // }
}
